import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function HeroSection() {
  return <section className="pt-32 pb-20 lg:pt-40 lg:pb-28 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto overflow-hidden" data-id="element-772" data-mp="2hvm1w11ux880">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-8 items-center" data-id="element-773" data-mp="23wmfz15qb7fj">
        {/* Left Column: Copy */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} className="max-w-2xl" data-id="element-774" data-mp="28w8v5g54axqz">
          <div className="inline-flex items-center gap-2 mb-6" data-id="element-775" data-mp="2ms305o2rt2yt">
            <span className="w-8 h-px bg-teal" data-id="element-776" data-mp="2rrfqiisuos65"></span>
            <span className="text-xs font-semibold text-teal uppercase tracking-[0.2em]" data-id="element-777" data-mp="3fius29csz5gc">
              Global Human-Capability Platform
            </span>
          </div>

          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-heading font-bold text-ink-dark leading-[1.1] mb-6 text-balance" data-id="element-778" data-mp="3kb4hzpdx45im">
            Building Better Judgment for a More Capable Society
          </h1>

          <p className="text-lg text-ink-muted mb-10 leading-relaxed max-w-xl" data-id="element-779" data-mp="2p5blkp28dcrn">
            SyNeural is the parent platform behind CJI and NCJI — a global
            human-capability, civic-development, and leadership-readiness
            framework designed to strengthen reasoning, reduce manipulation
            vulnerability, align talent with opportunity, and improve
            decision-making from early development to executive leadership.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 mb-6" data-id="element-780" data-mp="383nzeo437atk">
            <button className="bg-navy hover:bg-navy-light text-white font-medium px-6 py-3.5 rounded-md transition-colors shadow-sm flex items-center justify-center gap-2" data-id="element-781" data-mp="334uuvl6s2u5j">
              Request a Demo
              <ArrowRight size={18} data-id="element-782" data-mp="18s50718l5gx3" />
            </button>
            <button className="bg-transparent border border-navy text-navy hover:bg-surface-muted font-medium px-6 py-3.5 rounded-md transition-colors flex items-center justify-center" data-id="element-783" data-mp="38tb8dlwntwlc">
              Explore the Platform
            </button>
          </div>

          <p className="text-xs text-ink-muted font-medium" data-id="element-784" data-mp="3iqplbbjdk38w">
            For education, civil society, workforce systems, public
            institutions, and leadership development.
          </p>
        </motion.div>

        {/* Right Column: Abstract Diagram */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.2,
        ease: 'easeOut'
      }} className="relative h-[400px] lg:h-[500px] w-full flex items-center justify-center" data-id="element-785" data-mp="lcmbs58szxi">
          <div className="absolute inset-0 bg-gradient-to-tr from-surface-bg via-white to-surface-muted rounded-full blur-3xl opacity-50 -z-10" data-id="element-786" data-mp="jbm101i7uk63"></div>

          <svg viewBox="0 0 500 500" className="w-full h-full max-w-lg" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-787" data-mp="23sbmvwq0id68">
            {/* Background structural lines */}
            <circle cx="250" cy="250" r="200" stroke="#D9E2EC" strokeWidth="1" strokeDasharray="4 8" data-id="element-788" data-mp="1puwtkgwn1l8z" />
            <circle cx="250" cy="250" r="140" stroke="#D9E2EC" strokeWidth="1" data-id="element-789" data-mp="2ijkluwft1aw1" />
            <circle cx="250" cy="250" r="80" stroke="#D9E2EC" strokeWidth="1" strokeDasharray="2 4" data-id="element-790" data-mp="2dqrioczziam2" />

            {/* Connecting Pathways */}
            <path d="M100 350 C 150 350, 200 250, 250 250" stroke="#245B8F" strokeWidth="1.5" className="opacity-60" data-id="element-791" data-mp="31igdq146xd6p" />
            <path d="M250 250 C 300 250, 350 150, 400 150" stroke="#2E8C88" strokeWidth="1.5" className="opacity-60" data-id="element-792" data-mp="2q1qx0ory2oot" />
            <path d="M150 150 C 200 200, 250 250, 300 350" stroke="#123B5D" strokeWidth="1.5" className="opacity-40" data-id="element-793" data-mp="2c4c0z176rinv" />

            {/* Nodes & Labels */}
            {/* Individual */}
            <g transform="translate(100, 350)" data-id="element-794" data-mp="38r6xjc3mqh58">
              <circle cx="0" cy="0" r="6" fill="#FFFFFF" stroke="#245B8F" strokeWidth="2" data-id="element-795" data-mp="38u2v2zbkf3t5" />
              <text x="-10" y="20" fontSize="11" fill="#5B6675" fontFamily="Inter" textAnchor="middle" fontWeight="500" data-id="element-796" data-mp="3npiu7ir05pwe">
                Individual
              </text>
            </g>

            {/* Education */}
            <g transform="translate(150, 150)" data-id="element-797" data-mp="1n0e3j84h59d">
              <circle cx="0" cy="0" r="8" fill="#FFFFFF" stroke="#6FAE8A" strokeWidth="2" data-id="element-798" data-mp="1m8rgxwi6hv8" />
              <text x="0" y="-15" fontSize="11" fill="#5B6675" fontFamily="Inter" textAnchor="middle" fontWeight="500" data-id="element-799" data-mp="aipvlh6g9fhh">
                Education
              </text>
            </g>

            {/* Workforce */}
            <g transform="translate(250, 250)" data-id="element-800" data-mp="3nv079a6ee5l4">
              <circle cx="0" cy="0" r="12" fill="#FFFFFF" stroke="#123B5D" strokeWidth="2.5" data-id="element-801" data-mp="3nxcqdqnw6lzr" />
              <circle cx="0" cy="0" r="4" fill="#123B5D" data-id="element-802" data-mp="137ewpg7i9kt8" />
              <text x="20" y="4" fontSize="12" fill="#1F2A37" fontFamily="Inter" fontWeight="600" data-id="element-803" data-mp="1b4ypg3vq2yq8">
                Workforce
              </text>
            </g>

            {/* Civil Society */}
            <g transform="translate(300, 350)" data-id="element-804" data-mp="1p4zqpkfwg868">
              <circle cx="0" cy="0" r="10" fill="#FFFFFF" stroke="#2E8C88" strokeWidth="2" data-id="element-805" data-mp="ri12ly39w8jy" />
              <text x="0" y="22" fontSize="11" fill="#5B6675" fontFamily="Inter" textAnchor="middle" fontWeight="500" data-id="element-806" data-mp="11g71s7xp30l4">
                Civil Society
              </text>
            </g>

            {/* Government */}
            <g transform="translate(350, 220)" data-id="element-807" data-mp="dorx48ig476p">
              <circle cx="0" cy="0" r="14" fill="#FFFFFF" stroke="#245B8F" strokeWidth="2" data-id="element-808" data-mp="66jz6kuvawzw" />
              <text x="22" y="4" fontSize="11" fill="#5B6675" fontFamily="Inter" fontWeight="500" data-id="element-809" data-mp="3sds11d6kwlr6">
                Government
              </text>
            </g>

            {/* Leadership */}
            <g transform="translate(400, 150)" data-id="element-810" data-mp="3em3oj8sf3v9o">
              <circle cx="0" cy="0" r="18" fill="#FFFFFF" stroke="#123B5D" strokeWidth="3" data-id="element-811" data-mp="3elc48u49tjyp" />
              <circle cx="0" cy="0" r="26" stroke="#2E8C88" strokeWidth="1" strokeDasharray="2 2" data-id="element-812" data-mp="34qadxuy9ebuj" />
              <text x="0" y="-32" fontSize="12" fill="#1F2A37" fontFamily="Inter" textAnchor="middle" fontWeight="600" data-id="element-813" data-mp="2vpvr2r5ncoox">
                Leadership
              </text>
            </g>
          </svg>
        </motion.div>
      </div>
    </section>;
}